import { z } from 'zod';
import { paginationFiltersSchema, sortFiltersSchema } from 'utils/schemas';
import { brandProviders } from 'store/brands';
import { currencies, uppercaseContentLanguages } from 'types/general';
import { adminCardStatuses, adminCardPriceTypes } from './admin-cards.types';

export const adminCardsFiltersSchema = z
  .object({
    search: z.string().catch(''),
    status: z.array(z.enum(adminCardStatuses)).catch([]),
    brands: z.array(z.string()).catch([]),
    countries: z.array(z.string()).catch([]),
    providers: z.array(z.enum(brandProviders)).catch([]),
    priceType: z.array(z.enum(adminCardPriceTypes)).catch([]),
    languages: z.array(z.enum(uppercaseContentLanguages)).catch([]),
    currency: z.array(z.enum(currencies)).catch([]),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
